import styled from '@emotion/styled'

export const ButtonWrapper = styled.div`
  margin-left: auto;
`
